/**
 * TRANSLATION CORE (9/4/26) - pure functions, no React.
 *
 * Keys are the ENGLISH SENTENCES THEMSELVES, exactly as the UI rendered them before this layer
 * existed. That is the safety property of the whole feature: in English, `t(key)` returns the key,
 * so every screen, every test and every server-facing string is byte-for-byte what it was. A
 * Spanish entry that is missing does not blank the screen or throw - it falls back to English,
 * visibly, which is the honest failure.
 *
 * Placeholders are written `{name}` inside the key and filled from `vars`:
 *     t('Showing {count} of {total} orders', { count, total })
 * A placeholder with no value in `vars` is left as written so the gap is visible, never `undefined`.
 */

const PLACEHOLDER = /\{([A-Za-z0-9_]+)\}/g;

export function interpolate(text, vars) {
  if (typeof text !== 'string') return text;
  if (!vars || text.indexOf('{') === -1) return text;
  return text.replace(PLACEHOLDER, (match, name) =>
    Object.prototype.hasOwnProperty.call(vars, name) && vars[name] !== undefined && vars[name] !== null
      ? String(vars[name])
      : match,
  );
}

/**
 * Look `key` up in `dict` (null/undefined dict = English) and fill placeholders.
 * A non-string key (null, a number, a React element) is returned untouched - a component may pass
 * through whatever a helper handed it without checking the type first.
 */
export function translate(dict, key, vars) {
  if (typeof key !== 'string') return key;
  const text = dict && Object.prototype.hasOwnProperty.call(dict, key) && dict[key] ? dict[key] : key;
  return interpolate(text, vars);
}

/** The placeholders a string uses, for the dictionary integrity test. */
export function placeholdersOf(text) {
  const names = [];
  if (typeof text !== 'string') return names;
  text.replace(PLACEHOLDER, (match, name) => {
    names.push(name);
    return match;
  });
  return names.sort();
}
